import React from "react";

import userManager from "../../../services/auth/openIdClient";
import AnalyticsTracking from "../../../services/analytics-tracking/analytics-tracking";

const Auth = (WrappedComponent) =>
  class extends React.Component {
    constructor() {
      super();
      this.state = { isAuthenticated: false };
    }

    async componentDidMount() {
      await userManager.waitForReady();
      const current = await userManager.getUser();

      if (!current) {
        if (!userManager.isInteractionInProgress()) {
          await userManager.signinRedirect({
            state: { redirectUrl: window.location.href },
          });
        }
        return;
      }

      if (current.expired) {
        try {
          const refreshed = await userManager.signinSilent();
          this.setState({ isAuthenticated: !!refreshed });
        } catch (_) {
          if (!userManager.isInteractionInProgress()) {
            await userManager.signinRedirect({
              state: { redirectUrl: window.location.href },
            });
          }
        }
        return;
      }

      this.setState({ isAuthenticated: !!current });
      AnalyticsTracking.setUser(current.profile.sub);
    }

    render() {
      return this.state.isAuthenticated ? (
        <WrappedComponent {...this.props} />
      ) : null;
    }
  };

export default Auth;
